import React from "react";

import { DropdownSelectOption, DropDownSize } from "../..";
import { WhooshThemeColors } from "../../../../theme/restyle/theme";
import { ChevronDownIcon } from "../../../icons_v2/general/icons/ChevronDownIcon";
import { ChevronMiniDown } from "../../../icons_v2/general/icons/ChevronMiniDown";
import { HStack, Text, Box } from "../../../primitive";

type Props = {
  selectedItem: DropdownSelectOption<any> | null;
  includeLeftElementInSelectedValue: boolean;
  isDisabled: boolean;
  placeholder: string;
  hideLabelInDisplay: boolean;
  hideSubLabelInDisplay: boolean;
  testID?: string;
  ariaLabel?: string;
  size?: DropDownSize;
  backgroundColor?: WhooshThemeColors;
  hideChevron?: boolean;
  variant?: "default" | "compact";
};
export const TriggerDisplayValue = ({
  selectedItem,
  includeLeftElementInSelectedValue,
  isDisabled,
  placeholder,
  hideLabelInDisplay,
  hideSubLabelInDisplay,
  testID,
  ariaLabel,
  size,
  backgroundColor,
  hideChevron,
  variant,
}: Props) => {
  const textColor = isDisabled ? "text-secondary" : "text-primary";

  const shouldShowLeftElement =
    includeLeftElementInSelectedValue && selectedItem?.leftElement;

  const shouldShowLabelorSubLabel =
    !hideLabelInDisplay || (!!selectedItem?.subLabel && !hideSubLabelInDisplay);

  const isOnlyIcon = shouldShowLeftElement && !shouldShowLabelorSubLabel;

  return (
    <HStack
      px={isOnlyIcon ? 0 : variant === "compact" ? 2 : 4}
      borderRadius={"2"}
      alignItems="center"
      bg={backgroundColor}
      alignContent="center"
      justifyContent={isOnlyIcon ? "center" : "space-between"}
      aria-label={ariaLabel}
      {...getSizeStyles(size)}
      gap={isOnlyIcon ? 0 : 1}
      testID={`${testID}-trigger-display-value`}
    >
      {selectedItem?.triggerElement ? (
        selectedItem?.triggerElement
      ) : !!selectedItem ? (
        <HStack
          gap={3}
          alignItems="center"
          flex={1}
          overflow="hidden"
          justifyContent={isOnlyIcon ? "center" : "space-between"}
        >
          {shouldShowLeftElement ? selectedItem.leftElement : null}
          {shouldShowLabelorSubLabel ? (
            <HStack gap={2} flex={1}>
              {hideLabelInDisplay ? null : (
                <Text
                  variant="mainSmallSemiBold"
                  color={textColor}
                  numberOfLines={1}
                >
                  {selectedItem.label}
                </Text>
              )}
              {selectedItem.subLabel && !hideSubLabelInDisplay ? (
                <Text variant="mainBaseMedium" color={"text-secondary"}>
                  {selectedItem.subLabel}
                </Text>
              ) : null}
            </HStack>
          ) : null}
        </HStack>
      ) : (
        <Box flex={1}>
          <Text variant="mainSmallSemiBold" color={"text-secondary"}>
            {placeholder}
          </Text>
        </Box>
      )}
      {hideChevron ? null : variant === "compact" ? (
        <ChevronMiniDown
          testID="chevron-icon"
          color={isDisabled ? "icon-disabled" : "icon-primary"}
        />
      ) : (
        <ChevronDownIcon
          testID="chevron-icon"
          color={isDisabled ? "icon-disabled" : "icon-primary"}
        />
      )}
    </HStack>
  );
};

function getSizeStyles(size?: DropDownSize) {
  switch (size) {
    case "tiny":
      return {
        height: 32,
      };
    case "small":
      return {
        height: 40,
      };
    case "regular":
      return {
        height: 48,
      };
    case "large":
    default:
      return {
        height: 54, //Accomdate 2px border,
      };
  }
}
